export default [
  {
    key: '2', name: '报告生成', icon: 'pie-chart', submenus: [
      { key: '/page/chart/task', name: '任务列表'},
      { key: '/page/chart/report', name: '报告列表'}
    ]
  },
  {
    key: '3', name: '检测任务', icon: 'file-text', submenus: [
      { key: '/page/task/create', name: '创建任务'},
      { key: '/page/task/log', name: '任务列表'},
      { key: '/page/task/chart', name: '数据报表'},
    ]
  },
  {
    key: '4', name: '算法识别', icon: 'code', submenus: [
      { key: '/page/algorithm/log', name: '识别记录'},
      { key: '/page/algorithm/chart', name: '数据报表'}
    ]
  },
  {
    key: '5', name: '系统管理', icon: 'team', submenus: [
      { key: '/page/role', name: '角色管理' },
      { key: '/page/account', name: '员工账号' },
      { key: '/page/config', name: '系统配置' },
    ]
  },
]
